export default "__VITE_PUBLIC_ASSET__b532512a__"